import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Use the same env style you picked (CRA = REACT_APP_*)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY!,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FB_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET!,
  appId: process.env.REACT_APP_FB_APP_ID!,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
